import {fromJS} from 'immutable';
import _ from 'lodash';

export function createDataSource(features) {
  features = _.values(features); // convert to an array
  console.log('features',features)
  return {
    "type": "geojson",
    "data": {
      "type": "FeatureCollection",
      "features" : fromJS(features),
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/map.js